<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ OR-12390821390</b></div>
            <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: #8cc63e">คำสั่งซื้อใหม่</b></div>
            <!--            <div class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: grey">รอการลูกค้าชำระเงิน</b></div>-->
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลลูกหนี้</b></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อ : </div>
              <div class="ml-1 mr-3">นาย A</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div class="ml-1 mr-3">0238175826</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>ชำระหนี้</b></div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ยอดเงินเรียกเก็บ : </div>
                  <div class="ml-1 mr-3">{{ format_price(1780) }} บาท</div>
                </div>
                <div class="ml-1 mt-2" style="color: #86bc3a;">ผ่านการตรวจสอบการชำระเงินแล้ว</div>
                <div class="grid_flex mt-2" style="color: #86bc3a;">
                  <div class="ml-1 mr-3">ผู้ตรวจสอบ : </div>
                  <div class="ml-1 mr-3">Pharmacare Admin 28/03/2022 00.37 น.</div>
                </div>
              </div>
              <div class="mx-auto">
                <v-img @click="show_img()" class="mx-auto rounded cursor_img" height="160" width="160" max-width="160" :lazy-src="picture_holder" :src="picture_holder"></v-img>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการ</b></div>
              <template>
                <v-expansion-panels v-model="panel" :disabled="disabled">

                  <v-expansion-panel class="mb-3 pt-5 pb-5 rounded-xl">
                    <v-expansion-panel-header>
                      <div class="grid_three" style="font-size: 18px !important">
                        <div>เลขที่ : OR6500001</div>
                        <div>วันที่สั่งซื้อ 15 มีนาคม 2565 </div>
                        <div>ยอดการสั่งซื้อ  : 1,278.00 บาท</div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="ma-2">
                        <div class="grid_flex">
                          <div class="pr-2">ผู้รับ :</div>
                          <div>สุธิชา องค์วงศ์สกุล (0882677224)</div>
                        </div>
                        <div class="grid_flex">
                          <div class="pr-2">ที่อยู่ :</div>
                          <div>486/18 หนองหาร สันทราย เชียงใหม่ 50290</div>
                        </div>
                        <div class="mt-3">
                          <v-divider/>
                          <v-data-table class="color_table_1" :headers="headers" :items="data_list" :footer-props="footer_Props" mobile-breakpoint="0">
                            <template v-slot:item="dataDetail">
                              <tr>
                                <td class="pa-3">
                                  <div class="image_grid">
                                    <div class="mx-auto">
                                      <v-img height="64" width="64" max-width="64" v-if="imagePreviewURL === null" :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                                    </div>
                                    <div class="pa-2 pt-4 font_mobile">{{ dataDetail.item.product_name }}</div>
                                  </div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ dataDetail.item.price }}</div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ dataDetail.item.quantity }} {{ dataDetail.item.unit_name }}</div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ dataDetail.item.total }}</div>
                                </td>
                              </tr>
                            </template>
                            <template v-slot:body.append>
                              <tr>
                                <td colspan="2" class="text-right mr-3"><b>ค่าจัดส่ง</b></td>
                                <td></td>
                                <td class="text-center"><b>{{ format_number(49.00) }}</b></td>
                              </tr>
                              <tr>
                                <td colspan="2" class="text-right mr-3"><b>รวม</b></td>
                                <td></td>
                                <td class="text-center"><b>{{ format_price(123.26) }}</b></td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel class="mb-3 pt-5 pb-5 rounded-xl">
                    <v-expansion-panel-header>
                      <div class="grid_three" style="font-size: 18px !important">
                        <div>เลขที่ : OR6500001</div>
                        <div>วันที่สั่งซื้อ 15 มีนาคม 2565 </div>
                        <div>ยอดการสั่งซื้อ  : 1,278.00 บาท</div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      Some content
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                </v-expansion-panels>
              </template>
            </div>
          </v-card>
        </div>
        <v-dialog v-model="image_modal" max-width="600">
          <v-card>
            <v-form ref="image" @submit.prevent="">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ตรวจสอบการชำระเงิน</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="">
                  <div class="">ยอดชำระ : {{ format_number(100.32) }} บาท </div>
                </div>
                <div class="pa-6">
                  <v-img class="mx-auto rounded" height="300" width="300" max-width="300" :lazy-src="picture_holder" :src="picture_holder"></v-img>
                </div>
                <div class="mb-5">
                  <div class="">การชำระเงินของลูกค้า มีการโอนเงินที่ถูกต้องเรียบร้อยดีหรือไม่ ?</div>
                </div>
                <div class="text-right">
                  <v-btn elevation="5" @click="confirm_detail(0)" class="pa-6 grad-success-bg white--text rounded-pill mr-2 ml-2">การโอนเงินถูกต้อง</v-btn>
                  <v-btn elevation="5" @click="in_correct" class="pa-6 grad-danger-bg white--text rounded-pill mr-2 ml-2">ไม่ถูกต้อง</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <v-dialog v-model="preview_modal" max-width="512">
          <div v-if="loading_img === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card>
              <v-form ref="cancel" @submit.prevent="">
                <div class="d-flex justify-space-between">
                  <v-card-title>
                    หลักฐานการชำระเงิน
                  </v-card-title>
                  <v-btn icon class="ma-4" @click="preview_modal = false">
                    <v-icon color="grey">mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-text>
                  <div class="pa-1">
                    <v-img max-width="360" :lazy-src="picture_holder" :src="picture_holder" class="mx-auto"></v-img>
                    <div class="text-center mt-2" style="color: #8cc63e">ผู้อัพโหลด : Pharmacare Admin 28/03/2022 00.37 น.</div>
                  </div>
                  <div class="pa-1">
                    <v-img max-width="360" :lazy-src="picture_holder" :src="picture_holder" class="mx-auto"></v-img>
                    <div class="text-center mt-2" style="color: #8cc63e">ผู้อัพโหลด : Pharmacare Admin 28/03/2022 00.37 น.</div>
                  </div>
                </v-card-text>
              </v-form>
            </v-card>
          </div>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import img_holder from "@/assets/image-not-found.png";
// import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Transfer_correct",
  data() {
    return {
      loading_page: false,
      preview_modal: false,
      loading_img: false,
      picture_holder: picture_holder,
      img_holder: img_holder,
      imagePreviewURL: null,
      perPage: -1,
      image_modal: false,
      order_number: '',
      panel: 0,
      disabled: false,
      readonly: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'รายการสินค้าส่งคืน',
          value: '',
          fixed: true,
          sortable: false,
          width: '300px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '180px',
        },
        {
          text: 'รวม',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '180px',
        },
      ],
      data_list: [
        {
          id: 1,
          product_name: 'tab.POLIDENT Pro Retainer 30 tab 189.-',
          price: '189.00',
          quantity: '2',
          unit_name: 'กล่อง',
          total: '378.00',
        },
      ],
    }
  },
  methods: {
    format_number: function(value) {
      return formatNumber(value)
    },
    format_price: function(value) {
      return formatPrice(value)
    },
    get_edit() {
      const id = 1
      this.$router.push('/sell/ordercustomeredit/' + id)
    },
    confirm_detail() {
      this.$router.push('/sell/confirmorderdetail/' + this.$route.params.id)
    },
    in_correct() {
      const id = 1
      this.$router.push('/sell/payincorrect/' + id)
    },
    show_img() {
      this.preview_modal = true
      // this.loading_img = true
    },
  },
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}
.rounded_card {
  border-radius: 15px;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_flex {
  display: flex;
}
.grid_img {
  display: grid;
  grid-template-columns:70% 30%;
}
.border_table {
  border: #e0e0e0 solid 1px
}
.mobile_btn {
  width: 50%;
}
.display_pc {
  display: block;
}
.display_mobile {
  display: none;
}
.mobile_grid {
  width: 25%
}
.grid_three {
  display: grid;
  grid-template-columns: 25% 25% 50%;
}
.grid_flex {
  display: flex;
}
.color_table_1 >>> thead {
  background-color: #E2F5C7 !important;
}
.image_grid {
  display: grid;
  grid-template-columns: 15% 85%;
}
.cursor_img {
  cursor: pointer;
}
@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_grid {
    width: 32%
  }
  .image_grid {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .font_mobile {
    font-size: 14px !important;
  }
}
@media only screen and (max-width: 500px) {
  .mobile_grid {
    width: 100%;
    margin-bottom: 15px;
  }
  .grid_mx {
    margin: auto;
  }
  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }
  .mobile_btn {
    width: 100%;
  }
  .display_pc {
    display: none;
  }
  .display_mobile {
    display: block;
  }
}
</style>
